import React, { useEffect, useState } from "react";
import { toAbsoluteUrl } from "../../../_metronic";
import BetterBox from '../../components/BetterBox';
import BetterAlerts from '../../components/BetterAlerts';
import BetterCircularProgress from '../../components/BetterCircularProgress';
import { validarSenha, getInstrucoes, getPrograma } from '../../crud/tela-aula.crud';
import { TextField } from "@material-ui/core";
import { Button } from "react-bootstrap";
import Swal from "sweetalert2";
import TelaAulaExercicio from "../../components/TelaAulaExercicio";
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import moment from "moment";

export default function TelaAula(props) {
	const [errors, setErrors] = useState([]);
	const [senha, setSenha] = useState("");
	const [message, setMessage] = useState("");
	const [loading, setLoading] = useState(false);
	const [instrucoes, setInstrucoes] = useState([]);
	const [programa, setPrograma] = useState(null);
	const [instrucaoAtual, setInstrucaoAtual] = useState(null);
	const [exercicios, setExercicios] = useState([]);
	const [submitted, setSubmitted] = useState(false);
	const [showEstacao, setShowEstacao] = useState(false);
	const [segundos, setSegundos] = useState(0);

	const onSubmit = () => {
		if (!senha) {
			setErrors(["A senha é uma informação obrigatória."]);
			return;
		}

		setSubmitted(true);

		validarSenha(props.match.params.id_aula, props.match.params.estacao, senha).then(async (res) => {
			if (res.status == 200) {
				setShowEstacao(true);

				getPrograma(props.match.params.id_aula, props.match.params.estacao, senha).then((res) => {
					if (res.data) {
						setPrograma(res.data);
					}
				});
			}
		}).catch((e) => {
			Swal.fire('Ops!', "Senha inválida.", 'error');
		}).finally(() => {
			setSubmitted(false);
		});
	};

	const verificarNovasInstrucoes = () => {
		getInstrucoes(props.match.params.id_aula, props.match.params.estacao, senha, moment().format('YYYY-MM-DD HH:mm:ss')).then(async (res) => {
			if (res.status == 200) {
				if (res.data?.instrucoes?.length > 0) {
					if (JSON.stringify(instrucoes) != JSON.stringify(res.data.instrucoes)) {
						setInstrucoes(res.data.instrucoes);
						setExercicios(res.data.exercicios);
						setPrograma(res.data.programa);
					}
				}
			}
		}).catch((e) => {
			setMessage(e.response.data?.errors[0]);
			setInstrucoes([]);
			setInstrucaoAtual([]);
		});
	}

	const checkInstrucaoAtual = () => {
		const currentTime = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');

		let currentInstruction = null;

		for (let i = 0; i < instrucoes.length; i++) {
			const instruction = instrucoes[i];

			const startTime = moment(currentTime.format('YYYY-MM-DD') + ' ' + instruction.startTime, 'YYYY-MM-DD HH:mm:ss');
			const endTime = moment(currentTime.format('YYYY-MM-DD') + ' ' + instruction.startTime, 'YYYY-MM-DD HH:mm:ss').add(instruction.seconds, 'seconds');

			if (currentTime.isSameOrAfter(startTime) && currentTime.isBefore(endTime)) {
				currentInstruction = instruction;
				currentInstruction.secondsLeft = endTime.diff(currentTime, 'seconds');

				break;
			}
		}

		setInstrucaoAtual(currentInstruction);
		setSegundos(currentInstruction?.secondsLeft);
		playSound(currentInstruction);
	};

	const playSound = (currentInstruction) => {
		let sound = null;

		switch (currentInstruction?.type) {
			case "PREPARE":
				sound = "prepare.mp3";
				break;
			case "BURN":
				sound = "burn.mp3";
				break;
			case "REST":
				sound = "rest.mp3";
				break;
			case "SWITCH":
				sound = "switch.mp3";
				break;
		}

		if (sound) {
			const audio = new Audio(toAbsoluteUrl(`/audios/${sound}`));
			audio.play();
		}
	};

	const getMensagemInstrucaoAtual = () => {
		if (instrucaoAtual) {
			switch (instrucaoAtual.type) {
				case "PREPARE":
					return "PREPARAR!";
				case "BURN":
					return "BURNING!";
				case "REST":
					return "DESCANSO";
				case "SWITCH":
					return "TROCA DE EXERCÍCIO";
			}
		}
	};

	const getBackgroundInstrucaoAtual = () => {
		if (instrucaoAtual) {
			/*switch (instrucaoAtual.type) {
				case "PREPARE":
					return "#2A9E6A";
				case "BURN":
					return "#C23526";
				case "REST":
					return "#1B49A3";
				case "SWITCH":
					return "#1B49A3";
			}*/
			return programa?.pro_cor ?? "#C23526";
		}
	};

	useEffect(() => {
		checkInstrucaoAtual();
	}, [instrucoes]);

	useEffect(() => {
		const updateSegundos = setTimeout(() => {
			if (segundos - 1 > 0) {
				setSegundos(segundos - 1);
			} else {
				setSegundos(0);
				checkInstrucaoAtual();
			}
		}, 1000);

		return () => {
			clearTimeout(updateSegundos);
		};
	}, [segundos]);

	useEffect(() => {
		if (showEstacao) {
			verificarNovasInstrucoes();

			if (senha) {
				const checkMinuteStart = () => {
					const currentTime = new Date();
					const secondsUntilNextMinute = 60 - currentTime.getSeconds();

					setTimeout(() => {
						verificarNovasInstrucoes();
						checkMinuteStart();
					}, secondsUntilNextMinute * 1000);
				};

				checkMinuteStart();

				return () => {
					clearTimeout(checkMinuteStart);
				};
			}
		}
	}, [showEstacao]);

	return (
		<>
			{!showEstacao ?
				<div style={{ margin: '50px 0px 50px 0px' }}>
					<div className="row" style={{ margin: '0' }}>
						<div className="col-sm-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
							<div className="row">
								<div className="col-sm-12">
									<center>
										<img alt="Logo" src={toAbsoluteUrl("/images/logo-dark.png")} style={{ width: '250px', height: 'auto', marginTop: '35px', marginBottom: '35px' }} />
									</center>
								</div>

								<div className="col-sm-12">
									<BetterCircularProgress loading={loading}>
										<div>
											<div className="col-sm-12">
												<BetterAlerts errors={errors} />
											</div>

											<div>
												<div className="col-sm-12">
													<BetterBox title={`Digite a senha para acessar a estação ${props.match.params.estacao}.`}>
														<div className="col-sm-12">
															<div className='form-group fg-line'>
																<TextField type="text" name="senha" label="Senha *" margin="normal" variant="outlined"
																	onChange={(event) => setSenha(event.target.value)}
																/>
															</div>
														</div>
													</BetterBox>
												</div>

												<div className="col-sm-12">
													<center>
														<br />
														<Button className="btn btn-primary btn-lg btn-bold" onClick={() => onSubmit()}>
															<i className={`margin-icon ${submitted ? "fas fa-sync fa-spin" : "fa fa-check-square"}`}></i>Enviar
														</Button>
													</center>
												</div>
											</div>
										</div>
									</BetterCircularProgress>
								</div>
							</div>
						</div>
					</div>
				</div>
				:
				<>
					{instrucoes.length == 0 || !instrucaoAtual ?
						<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100wh', height: '100vh', background: '#151416' }}>
							<img alt="Logo" src={toAbsoluteUrl("/images/fitness-logo-white.png")} style={{ width: '280px', height: 'auto', padding: '0px 40px' }} />

							<div className="divSep" />

							<div>
								<p className="burningDone">BURNING DONE!</p>
								{message &&
									<p className="message">
										{message}
									</p>
								}

								<p className="nomeEstacao">
									Estação {props.match.params.estacao} - {programa?.pro_nome}
								</p>
							</div>
						</div>
						:
						<div className="telaAulaContainer">
							<div className="telaAulaCounterContainer">
								<div className="telaAulaCounterContainerCounter">
									<CircularProgressbarWithChildren value={segundos} maxValue={instrucaoAtual?.seconds}
										styles={{
											path: {
												stroke: `${getBackgroundInstrucaoAtual()}`,
												strokeLinecap: 'butt',
											},
											trail: {
												stroke: '#2e2c30',
												strokeLinecap: 'butt',
											}
										}} strokeWidth={4}>

										{instrucaoAtual?.type != "BURN" &&
											<p className="telaAulaCounterMessage">Começa em</p>
										}

										<p className="telaAulaCounterNumber">{segundos}</p>
									</CircularProgressbarWithChildren>
								</div>
							</div>

							<div className="telaAulaBoxExercicio" style={{ backgroundColor: `${getBackgroundInstrucaoAtual()}` }}>
								<div className="telaAulaBoxLogoContainer">
									<img alt="Logo" src={toAbsoluteUrl("/images/logo-white.png")} className="telaAulaLogo" />
									<p className="telaAulaEstacaoTitle">Estação {props.match.params.estacao} - {programa?.pro_nome}</p>
								</div>

								<div className="telaAulaWhatToDoContainer">
									<p className="telaAulaWhatToDoTitle">{getMensagemInstrucaoAtual()}</p>
									<p className="telaAulaWhatToDoCounter"><span className="telaAulaWhatToDoNumber">{instrucaoAtual?.serie}</span>/9</p>
								</div>
							</div>

							<TelaAulaExercicio customVideoClass='borderOnBottomVideo' letra="A" nome1={instrucaoAtual?.alunos.find(e => e.posicao == 'A1')?.nome}
								nome2={instrucaoAtual?.alunos.find(e => e.posicao == 'A2')?.nome} videoUrl={exercicios?.A?.url} />

							<TelaAulaExercicio customVideoClass='borderOnRightVideo' namesBottom letra="B" nome1={instrucaoAtual?.alunos.find(e => e.posicao == 'B1')?.nome}
								nome2={instrucaoAtual?.alunos.find(e => e.posicao == 'B2')?.nome} videoUrl={exercicios?.B?.url} />

							<TelaAulaExercicio namesBottom letra="C" nome1={instrucaoAtual?.alunos.find(e => e.posicao == 'C1')?.nome}
								nome2={instrucaoAtual?.alunos.find(e => e.posicao == 'C2')?.nome} videoUrl={exercicios?.C?.url} />
						</div>
					}
				</>
			}
		</>
	);
}